export interface BusinessLocationPin {
  latitude: number;
  longitude: number;
}

export function normalizeBusinessLocationPin(
  latitude: number,
  longitude: number,
): BusinessLocationPin {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    throw new RangeError("Business location coordinates must be finite numbers.");
  }
  const clampedLatitude = Math.max(-90, Math.min(90, latitude));
  const wrappedLongitude = ((((longitude + 180) % 360) + 360) % 360) - 180;
  return {
    latitude: Number(clampedLatitude.toFixed(6)),
    longitude: Number(wrappedLongitude.toFixed(6)),
  };
}
